import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { Row, Col } from 'react-bootstrap';

import { getRatingCriteries } from '../common/redux/actions/RatingCriteriesActions';
import EmojiRating from './EmojiRating';
import { roundedOverallRatingScore } from '../common/utilities/ratings';

const DetailedRatings = (props, context) => {
  const { overallScore, scoresForEachCriteria } = props;
  const dispatch = useDispatch();

  const ratingCriteries = useSelector((state) => state.RatingCriteriesState);

  useEffect(() => {
    if (!ratingCriteries.fetched) {
      dispatch(getRatingCriteries());
    }
  }, []);

  return (
    <div className='mt-3' style={{ textAlign: 'left' }}>
      <Row>
        <Col xs={7}>
          <p style={{ display: 'inline', margin: 0, fontWeight: 500 }}>
            {' '}
            {context.t('Overall:')}{' '}
          </p>
        </Col>
        <Col xs={5} className='rating-overall-row'>
          <EmojiRating score={roundedOverallRatingScore(overallScore)} interactive={false} small />
          <span>
            {' '}
            {(overallScore && overallScore.toFixed(1))
              || '0.0'}{' '}
          </span>
        </Col>
      </Row>
      {scoresForEachCriteria?.map((item, key) => {
        const ratingCriteria = ratingCriteries.items[item.rating_criteria_id];
        return (
          <Row key={key}>
            <Col xs={7}>
              <p style={{ display: 'inline', margin: 0 }}>
                {' '}
                {ratingCriteria && ratingCriteria.name}:{' '}
              </p>
            </Col>
            <Col xs={5} className='rating-overall-row'>
              <EmojiRating score={roundedOverallRatingScore(item.score)} interactive={false} small />
              <span> {item.score.toFixed(1)} </span>
            </Col>
          </Row>
        );
      })}
    </div>
  );
};

export default memo(DetailedRatings);

DetailedRatings.contextTypes = {
  t: PropTypes.func.isRequired
};

DetailedRatings.defaultProps = {
  scores_for_each_criteria: []
};
